import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExceptionHandlingService {
  constructor() {}

  isAccessUnauthorized(err: any) {
    if (err && err.status && (err.status === 401 || err.status === 403)) {
      return true;
    }
  }
}
